/* src/app/components/discovery/dialogs/production-withheld-log-dialog/production-withheld-log-dialog.component.scss */
.mat-mdc-dialog-content {
  padding: 12px 24px 12px 24px;
  min-width: 200px;
  min-height: 50px;
  display: flex;
  flex-direction: column;
}
.mat-mdc-dialog-title {
  padding: 24px 24px 24px 20px;
  margin: -24px -24px 10px -24px;
  background-color: rgb(48, 63, 159);
  color: white;
}
.row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
}
.item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  border: 1px solid #bdbdbd;
  border-radius: 3px;
  padding: 19px;
  margin: 1px;
  font-weight: 400;
  cursor: pointer;
}
.item mat-icon {
  color: rgba(48, 63, 159, 0.9098039216);
}
.primary-item {
  flex-grow: 1;
}
:host-context(.dark-theme) .item {
  border: 1px solid #656565;
}
:host-context(.dark-theme) .item mat-icon {
  color: #88a3ff;
}
/*# sourceMappingURL=production-withheld-log-dialog.component.css.map */
